import * as React from "react";
import styled, { css } from "styled-components";
import { Link } from "components/common";
import { Alert } from "components/bootstrap";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import DocsHelper from "util/DocsHelper";
import useUsageWarningAcknowledgementMutation from "license/notifications/hooks/useUsageWarningAcknowledgementMutation";
import LicensesRoutes from "license/Routes";
const StyledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
  `
);
const LicenseUsageWarningNotification = ({ remainingVolume }) => {
  const currentUser = useCurrentUser();
  const { acknowledgeNotifcation } = useUsageWarningAcknowledgementMutation();
  const onDismiss = () => {
    acknowledgeNotifcation();
  };
  const bsStyle = remainingVolume <= 40 ? "warning" : "info";
  if (remainingVolume === void 0) return null;
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle, title: "Graylog License Volume", onDismiss }, /* @__PURE__ */ React.createElement("p", null, "Notification that your", " ", isPermitted(currentUser == null ? void 0 : currentUser.permissions, "licenses:create") ? /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }, "Graylog License") : "Graylog License", " ", "has less than ", remainingVolume, "% of its volume entitlement remaining. ", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("span", null, "The ", /* @__PURE__ */ React.createElement(Link, { to: DocsHelper.toString(DocsHelper.PAGES.LICENSE_MANAGEMENT) }, "Licenses Page"), " details which Enterprise features will be disabled when no valid Graylog License is present. Please contact your Graylog Account Manager for further information and renewals.")));
};
export default LicenseUsageWarningNotification;
